import { useState } from "react"
import { supabase } from "../../lib/supabaseClient"

export function useRegisterForm(onSuccess = () => {}) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [company, setCompany] = useState("")
  const [err, setErr] = useState("")
  const [loading, setLoading] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setErr("")

    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { company } },
    })

    if (error) {
      setErr(error.message)
      setLoading(false)
      return
    }

    // Insertar en la tabla clients
    const { error: insertError } = await supabase.from("clients").insert({
      id_client: data.user.id,
      client_name: company,
    })

    setLoading(false)

    if (insertError) {
      setErr(insertError.message)
    } else {
      onSuccess()
    }
  }

  return {
    email,
    setEmail,
    password,
    setPassword,
    company,
    setCompany,
    err,
    loading,
    submit,
  }
}
